"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Opens a "Popout" panel who listens to this session's events
 */
function openPopoutPanel() {
  var destinationUrl = new URL(document.location);
  destinationUrl.searchParams.set('eaDebugPanel', 'popout');
  window.open(destinationUrl.href, '_blank', 'location=1,status=1,scrollbars=1');
}
var _default = exports["default"] = openPopoutPanel;